import { useCreateWhatsNewNotifications } from 'components/notifications-manager/useCreateWhatsNewNotifications';
import { useListFilteredNotifications } from 'queries/notifications';

export const NotificationsManager = () => {
  const { data: notifications, isLoading, isError } = useListFilteredNotifications();

  useCreateWhatsNewNotifications(isLoading || isError ? undefined : notifications);
  return null;
};
